import Image from '@creator/ui/components/Image/Image';
import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import { usePost } from '@src/store/posts/hooks/usePost';
import { usePostImage } from '@src/store/posts/hooks/usePostImage';
import { Fragment, type FC } from 'react';
import { PostTitleAndByline } from './PostTitleAndByline';
import HelpTip from '@creator/ui/components/Helptip/Helptip';

export interface PostHeroProps {
    className?: string;
    postId: string;
    tokenName: string;
}

export const PostHero: FC<PostHeroProps> = props => {
    const { postId, tokenName, className } = props;
    const post = usePost(postId);
    const { url: heroImage, imageMetadata } = usePostImage({ postId, imageType: 'hero' });

    const simulatedAvatarWidth = "w-[calc(64px_+_theme('spacing.3'))] lg:w-[calc(100px_+_theme('spacing.4'))]";

    function renderCover() {
        const imageSrc = heroImage;
        const alt = `${post?.title || ''} cover image`;
        return <Image fetchPriority="high" alt={alt} src={imageSrc} className="w-full object-cover object-center aspect-[16/9] lg:aspect-[21/9]" />;
    }

    function renderCredit() {
        if (!imageMetadata?.credit) return null;
        return (
            <div className="h-5">
                <HelpTip tooltipPosition="left" className="lg:hidden" text={imageMetadata.credit} />
                <Text className="hidden text-xs text-gray-400 lg:block">{imageMetadata.credit}</Text>
            </div>
        );
    }

    return (
        <div className={cn('relative', className)}>
            {renderCover()}
            <div
                className={
                    'absolute bottom-0 left-0 right-0 px-4 pb-1 lg:pb-2 flex text-gray-50 items-end bg-[linear-gradient(180deg,rgba(2,6,23,0)_2.04%,rgba(2,6,23,0.8)_78.47%)] h-1/3'
                }
            >
                <div className={cn('flex-shrink-0', simulatedAvatarWidth)} />
                <PostTitleAndByline postId={postId} tokenName={tokenName} className={'flex-1 min-w-0'} />
                {renderCredit()}
            </div>
        </div>
    );
};
